import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/users')({
  head: () => ({
    meta: [{ title: 'Users | Tekst' }],
  }),
});
